
import {
    Box,
    Typography,
} from "@mui/material";
import React, { useContext, } from "react";

import Logo from "src/components/Logo";

import SideBg from "src/views/welcome/SideBg";
import { Users } from "src/context";
import Page from "src/components/Page";
import SM from "src/assets/images/sent-mail.png";
import { useLocation } from "react-router-dom";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}
const MagicLinkSuccessLogin = () => {

    const searchParams = useQuery();
    const email = searchParams.get("email");
    const { mixpanel } = useContext(Users);




    React.useEffect(() => {
        mixpanel.track("Magic Link Success Login", {
            location: window.location.href,
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Page title="Login">
            <Box
                sx={(themes) => ({
                    height: "80px",
                    alignItems: "center",
                    [themes.breakpoints.up("md")]: {
                        alignItems: "center",
                        boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.04)",
                        pl: "99px",
                        display: "none",
                    },
                    [themes.breakpoints.down("md")]: {
                        justifyContent: "flex-start",
                        pl: "24px !important",

                        display: "flex",
                    },
                })}
            >
                <Logo />
            </Box>

            <Box
                sx={{
                    minHeight: { xs: "calc(100vh - 120px)", md: "calc(100vh - 0px)" },
                    justifyContent: "space-between",
                    display: "flex",
                }}
            >
                <Box
                    sx={{
                        pt: {
                            md: "120px",
                        },
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                    }}
                >
                    <Box
                        sx={{
                            width: { xs: "100%", md: "440px" },
                        }}
                    >
                        <Box sx={{ mt: "24px", textAlign: "center" }}>
                            <Box sx={{ mb: 2 }}>
                                <img
                                    alt={"Treffas logo"}
                                    src={SM}
                                    style={{
                                        width: "199.08px",
                                        height: "168px",
                                    }}
                                />
                            </Box>

                            <Typography
                                sx={{
                                    fontSize: "18px",
                                    lineHeight: "24px",
                                    fontWeight: 500,
                                    color: "#19181B",
                                    mb: 1,
                                    fontFamily: "var(--font-work-sans)",
                                }}
                            >
                                {"Check your email"}
                            </Typography>

                            <Typography
                                sx={{
                                    fontSize: "14px",
                                    lineHeight: "20px",
                                    color: "#6E757C",
                                    mb: 3,
                                    fontFamily: "var(--font-work-sans)",
                                }}
                            >
                                We've sent a magic link to <span style={{ color: "var(--color-brand-primary)", fontWeight: 500 }}> {email}</span>. Click the link in the email to sign in.
                            </Typography>
                        </Box>
                    </Box>
                </Box>

                <Box
                    sx={{
                        overflow: "hidden",
                        width: "1100px",
                        display: { xs: "none", lg: "block" },
                    }}
                >
                    <SideBg />
                </Box>
            </Box>
        </Page>
    );
};

export default MagicLinkSuccessLogin;
